import React from 'react'
import { Input as RsInput } from 'reactstrap'
import NumericInput from 'react-numeric-input'

class Input extends React.PureComponent {
  handleChange = (e) => {
    this.props.onChange(e.target.value)
  }
  handleNumericInputChange = (e) => this.props.onChange(e)
  render () {
    const { onChange, isNumeric, className, ...otherProps } = this.props
    if (isNumeric === true) {
      return <NumericInput
        onChange={this.handleNumericInputChange}
        className={`form-control ${className || ''}`}
        {...otherProps}
      />
    }
    return <RsInput onChange={this.handleChange} {...otherProps} />
  }
}

export {
  Input
}